// Shared by delivered screens and the existing settings/forms.
export const BUTTON_RADIUS = 12;
